interface OnboardingContentFrameProps {
  title: string
  description: string
  stepLabel: string
  children: React.ReactNode
}

export function OnboardingContentFrame({
  title,
  description,
  stepLabel,
  children,
}: OnboardingContentFrameProps) {
  return (
    <section className="animate-fade-in-up rounded-2xl border border-white/70 bg-white p-5 shadow-[0_14px_45px_rgba(0,0,0,0.08)] sm:p-7">
      <div className="mb-6 flex flex-wrap items-center gap-3">
        <span className="rounded-full bg-spectrum-blue/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-spectrum-blue">
          {stepLabel}
        </span>
        <div>
          <h2 className="text-xl font-bold text-gray-900 sm:text-2xl">{title}</h2>
          <p className="text-sm text-gray-600">{description}</p>
        </div>
      </div>
      <div className="animate-scale-in">{children}</div>
    </section>
  )
}
